import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();

import config from "@/_store/modules/credentials-config"

export default factory.generateVuexModule(config);
